export default __webpack_public_path__ + "static/media/telegramMobileLogo.45ca91cf.svg";